import { PrintArea, ProductType } from '@/types';
import { fetchProductType } from '@/utils/http/fetchProductType';
import { Thunk } from '@/redux/types';
import { getProductTypeById } from '../getters/getProductTypeById';
import { ProductTypesSetAction } from '../types';
import { setProductTypeAction } from './setProductTypeAction';

const fixPrintAreaBoundary = (printArea: PrintArea) => {
  printArea.boundary.size.height = Math.floor(printArea.boundary.size.height);
  printArea.boundary.size.width = Math.floor(printArea.boundary.size.width);
};

const pendingFetches = new Map<string, Promise<ProductType>>();
export const fetchProductTypeAction =
  (productTypeId: string): Thunk<Promise<ProductType>, ProductTypesSetAction> =>
  (dispatch, getState) => {
    const productType = getProductTypeById(getState(), productTypeId);
    if (productType) {
      return Promise.resolve(productType);
    }

    const pendingFetch = pendingFetches.get(productTypeId);
    if (pendingFetch) {
      return pendingFetch;
    }

    const newFetch = fetchProductType(productTypeId).then((productType) => {
      pendingFetches.delete(productTypeId);
      productType.printAreas.forEach(fixPrintAreaBoundary);
      productType.views = productType.views
        .filter((v) => v.state === 'ACTIVATED')
        .sort((a, b) => (a.perspective === null ? 1 : b.perspective === null ? -1 : 0));
      return dispatch(setProductTypeAction(productType));
    });

    pendingFetches.set(productTypeId, newFetch);
    return newFetch;
  };
